import * as angular from 'angular';
import { ApplicationTeamService } from './ApplicationTeamService';
export const applicationTeamModule = angular
    .module('app.applicationTeam', [])
    .service('ApplicationTeamService', ApplicationTeamService)
    .name;
